import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewCardListType } = listModuleLenses

export default (state, { moduleId }) => viewCardListType(moduleId, moduleDescriptions)
